import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BundleType, BundleTypeKeys, type RootState } from '@/store';
import { BundleCategoryItem } from '@/api';

interface BundleCategoryListState {
  bundleCategoriesList: BundleCategoryItem[];
}

const initialState: BundleCategoryListState = {
  bundleCategoriesList: []
};

const bundleCategoryListSlice = createSlice({
  name: 'bundleCategoryList',
  initialState: {
    [BundleType.LIGHT]: initialState,
    [BundleType.FULL]: initialState
  } as Record<BundleTypeKeys, BundleCategoryListState>,
  reducers: {
    setBundleCategoriesList: (
      state,
      action: PayloadAction<{
        key: BundleTypeKeys;
        data: BundleCategoryItem[];
      }>
    ) => {
      const { key, data } = action.payload;
      state[key].bundleCategoriesList = data;
    }
  }
});

export const { setBundleCategoriesList } = bundleCategoryListSlice.actions;

// RTK SELECTORS WITHOUT CALLBACK

export const selectBundleCategoriesList = (state: RootState) => {
  const activeBundleType = state.sharedData.activeBundleType;
  return activeBundleType
    ? state.bundleCategoryList[activeBundleType].bundleCategoriesList
    : initialState.bundleCategoriesList;
};

export const bundleCategoryListReducer = bundleCategoryListSlice.reducer;
